<template>
	<div class="prize-image" :style="style"></div>
</template>

<script>
export default {
	name: 'PrizeImage',
	props: {
		url: String,
	},
	computed: {
		style() {
			const url = process.env.VUE_APP_API + this.url
			return {
				backgroundImage: `url(${url})`,
			}
		},
	},
}
</script>

<style lang="scss" scoped>
@import '~scss/components';

.prize-image {
	@include circle(7.5rem);
	background-color: $col-primary;
}
</style>
